import { FC, ReactNode } from 'react'
import useStore from 'store/Store'
import { Navigate } from 'react-router-dom'

interface IProps {
    children: ReactNode
}

const NotEvansAdminGuard: FC<IProps> = ({ children }) => {
    const { isEvansAdmin } = useStore()

    if (!isEvansAdmin) {
        return <>{children}</>
    }

    return <Navigate to="/ride-to-work-apply/evans-admin/companies" />
}

export default NotEvansAdminGuard
